import React from 'react';
import { observer } from 'mobx-react';
import { DrawingToolsetViewModel } from '../viewModel/DrawingToolsetViewModel';
import { DrawingTextInputView } from './DrawingTextInputView';
import { DrawingToolsetView } from './DrawingToolsetView';

interface IDrawingToolboxViewProps {
  drawingTools: DrawingToolsetViewModel;
}

export const DrawingToolboxView = observer((props: IDrawingToolboxViewProps) => {
  return (
    <div>
      <DrawingToolsetView drawingTools={props.drawingTools} />
      {props.drawingTools.textTool.isActive && (
        <DrawingTextInputView textSketchInputProps={props.drawingTools.textTool.textDrawingProps!} />
      )}
    </div>
  );
});
